import dayjs from 'dayjs';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { MenuPlanningPage } from '@wonderschool/common-food-program-ui';
import { getTitlePrefix } from '../../../config/env';
import { RouteNameEnum, useRoutes } from '../../../navigation';
import { PAGE_NAMES, useSegmentPage } from '../../../segment';

const MenuPlanning = () => {
  const { t } = useTranslation();
  const { gotoRouteByName } = useRoutes();
  const location = useLocation();
  const navigate = useNavigate();
  useSegmentPage(PAGE_NAMES.foodProgramMenuPlanning);

  const queryParams = new URLSearchParams(location.search);
  const date = queryParams.get('date');
  const menuEventDate = date ? dayjs(date).toDate() : new Date();

  // strip off the query parameters
  useEffect(() => {
    // Check if there are any query parameters
    if (location.search) {
      // Remove the query parameters by navigating to the same path without them
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  const renderPageHead = () => (
    <Helmet>
      <title>
        {getTitlePrefix()}
        {t('foodProgram.menu.planning.browserTitle', { pageName: t('food.menu.planning') })}
      </title>
      <body />
    </Helmet>
  );

  const handleClickEditMeals = (date: Date) => {
    gotoRouteByName(RouteNameEnum.FOOD_PROGRAM_MENU_PLANNING_EDIT, [
      {
        name: 'date',
        value: date.toISOString().split('T')[0],
      },
    ]);
  };

  return (
    <>
      {renderPageHead()}
      <MenuPlanningPage
        onClickEditMeals={handleClickEditMeals}
        onClickPrintMenu={() => null}
        menuEventDate={menuEventDate}
      />
    </>
  );
};
export default MenuPlanning;
